import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosPersonalesComponent } from '../../../comun/components/datos-personales/datos-personales.component';
import { DatosDomicilioComponent } from '../../../comun/components/datos-domicilio/datos-domicilio.component';
import { DatosContactoComponent } from '../../../comun/components/datos-contacto/datos-contacto.component';
import { DatosPagoComponent } from '../../../comun/components/datos-pago/datos-pago.component';
import { DatosComplementariosComponent } from '../../../comun/components/datos-complementarios/datos-complementarios.component';
import { PolizaSalud } from '../../../comun/model/salud.model';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule } from '@ngx-translate/core';
import { DatosPersonalesConfig, DatosDomicilioConfig, ModoEdicion } from '../../../ui/model/catalogo-config.model';
import { CatalogoGeneralStoreService } from '../../../comun/services/store/catalogo-general-store.service';

@Component({
	selector: 'app-datos-cliente',
	standalone: true,
	imports: [
		CommonModule,
		DatosPersonalesComponent,
		DatosDomicilioComponent,
		DatosContactoComponent,
		DatosPagoComponent,
		DatosComplementariosComponent,
		CaCardComponent,
		TranslateModule
	],
	templateUrl: './datos-cliente.component.html',
	styleUrls: ['./datos-cliente.component.scss']
})
export class DatosClienteComponent implements OnInit{
	@Input() poliza: PolizaSalud;

	tomadorConfig: DatosPersonalesConfig;
	domicilioTomadorConfig: DatosDomicilioConfig;
	domicilioPrestacionConfig: DatosDomicilioConfig;

	constructor(private catalogoGeneralStore: CatalogoGeneralStoreService) { }	

	ngOnInit(): void {
		this.tomadorConfig = {
			persona : this.poliza?.tomador,
			rol: 'cliente_tomador',
			modoEdicion: ModoEdicion.NO,
			mostrarDocumento :true,
			mostrarNombre : true,
			mostrarFechaNacimiento: true,
			mostrarSexo: true
		}

		this.domicilioTomadorConfig = {
			domicilio : this.poliza.tomador?.domicilio,
			rol: 'tomador',
			modoEdicion: ModoEdicion.NO,
			mostrarVia :true,
			mostrarLocalidad: true,
			mostrarProvincia: true
		}

		this.domicilioPrestacionConfig = {
			domicilio : this.poliza.domicilioPrestacion,
			rol: 'prestacion',
			modoEdicion: ModoEdicion.NO,
			mostrarVia :true,
			mostrarLocalidad: true,
			mostrarProvincia: true
		}
		this.catalogoGeneralStore.getTiposVia();
		this.catalogoGeneralStore.getProvincias();
	}
}
